export type RequestSequence = { current: number }

export type LatestRequest = {
  signal: AbortSignal
  isCurrent: () => boolean
  cancel: () => void
}

export const createLatestRequest = (
  sequence: RequestSequence
): LatestRequest => {
  const requestId = ++sequence.current
  const controller = new AbortController()
  let active = true

  return {
    signal: controller.signal,
    isCurrent: () => active && requestId === sequence.current,
    cancel: () => {
      active = false
      controller.abort()
    },
  }
}
